import { render, staticRenderFns } from "./CardTeamMembers.vue?vue&type=template&id=5b7d37ee&scoped=true&"
import script from "./CardTeamMembers.vue?vue&type=script&lang=js&"
export * from "./CardTeamMembers.vue?vue&type=script&lang=js&"
import style0 from "./CardTeamMembers.vue?vue&type=style&index=0&id=5b7d37ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d37ee",
  null
  
)

export default component.exports